import { getCookie } from "./cookie";

/**
 * @returns object | undefined
 */
export function getLoginPayload() {
	try {
		return JSON.parse(atob(getCookie("esc-sec-token")?.split(".")[1]))?.data;
	} catch {
		return;
	}
}
